import { LogoMark } from "./Logo";

export const EbookCover = ({ book }) => {
  const [c1, c2] = book.cover;
  return (
    <div className="relative mx-auto w-[58%] [perspective:1100px]">
      <div className="book relative aspect-[3/4] [transform-style:preserve-3d]">
        <div className="absolute inset-0 rounded-r-md rounded-l-sm overflow-hidden shadow-[18px_24px_50px_-12px_rgba(0,0,0,0.75)]"
          style={{ background: `linear-gradient(150deg, ${c1}, ${c2})`, color: book.ink }}>
          <div className="absolute inset-y-0 left-0 w-3 bg-gradient-to-r from-black/45 via-black/10 to-transparent" />
          <div className="absolute inset-y-0 left-3 w-px bg-white/15" />
          <div className="absolute inset-3 left-5 border" style={{ borderColor: `${book.ink}40` }} />
          <div className="relative flex h-full flex-col justify-between p-5 pl-7">
            <span className="font-mono text-[10px] tracking-[0.3em]">VOL. {book.vol}</span>
            <p className="font-display text-[1.2rem] sm:text-[1.35rem] leading-[1.08]">{book.title}</p>
            <div className="flex items-center gap-2">
              <LogoMark className="h-5 w-5" color={book.ink} />
              <span className="font-mono text-[9px] uppercase tracking-[0.25em]">Rinda Marbun</span>
            </div>
          </div>
          <div className="book-gloss absolute inset-0" />
        </div>
      </div>
    </div>
  );
};
